import { PayloadAction } from 'app/shared/model/action.model';

export const GET_MODEL_TYPES = 'GET_MODEL_TYPES';
export class GetModelTypes implements PayloadAction {
  readonly type = GET_MODEL_TYPES;
  constructor(public payload?) {
  }
}

export const GET_MODEL_TYPES_SUCCESS = 'GET_MODEL_TYPES_SUCCESS';
export class GetModelTypesSuccess implements PayloadAction {
  readonly type = GET_MODEL_TYPES_SUCCESS;
  constructor(public payload) { }
}

export const GET_TIRE_SIZES = 'GET_TIRE_SIZES';
export class GetTireSizes implements PayloadAction {
  readonly type = GET_TIRE_SIZES;
  constructor(public payload?) {
  }
}

export const GET_TIRE_SIZES_SUCCESS = 'GET_TIRE_SIZES_SUCCESS';
export class GetTireSizesSuccess implements PayloadAction {
  readonly type = GET_TIRE_SIZES_SUCCESS;
  constructor(public payload) { }
}

export const GET_PROVIDER_LOCATIONS = 'GET_PROVIDER_LOCATIONS';
export class GetProviderLocations implements PayloadAction {
  readonly type = GET_PROVIDER_LOCATIONS;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_PROVIDER_LOCATIONS_SUCCESS = 'GET_PROVIDER_LOCATIONS_SUCCESS';
export class GetProviderLocationsSuccess implements PayloadAction {
  readonly type = GET_PROVIDER_LOCATIONS_SUCCESS;
  constructor(public payload) { }
}

export type LoanerWheelInventoryActions = GetModelTypes | GetModelTypesSuccess |
  GetTireSizes | GetTireSizesSuccess | GetProviderLocations | GetProviderLocationsSuccess;